/* eslint-disable */

<template>
    <div class="d-flex flex-column">
    <v-card>
        <v-card-text>
            <div class="d-flex align-center justify-center flex-column my-8" v-if="loading_dbs">
              <h2>Login e sincronizzazione dati in corso...</h2>
              <v-progress-circular 
                  indeterminate
                  size="200"
                  width="20"
                  color="primary"
                  ></v-progress-circular>
            </div>
            <div v-else>
            <v-alert type="error" v-if="error">
              <div v-if="error=='dbSync'">
                  Errore di sincronizzazione dei dati: se il problema persiste, contattare l'amministratore di sistema.
              </div>
              <div v-else>
                  Si è presentato un errore inaspettato: se il problema persiste, contattare l'amministratore di sistema.
              </div>
            </v-alert>
            <div class="d-flex justify-end full-width">
                <v-img max-width="242" max-height="242" :src="image_data" />
            </div>
            <div class="d-flex flex-column mt-4">
                <v-text-field dense outlined
                  v-model="username"
                  label="username*"
                  hint="Enter your username"
                  required
                  :rules="[rules.mandatory]"
                ></v-text-field>
                <v-text-field dense outlined
                  v-model="password"
                  :type="'password'"
                  label="password*"
                  :rules="[rules.mandatory, rules.nameRules]"
                ></v-text-field>
            </div>
            <!--div class="mt-4 font-weight-bold">
                {{welcome_message.head.toUpperCase()}}
                {{welcome_message.body_first.toUpperCase()}}
                {{welcome_message.body_second.toUpperCase()}}
            </div-->
            <v-alert type="error" :value="login_error">
              {{errorMessage}}
            </v-alert>
            </div>
        </v-card-text>
        <v-card-actions class="d-flex align-center justify-center" v-if="!loading_dbs">
            <div>
            <v-btn :disabled="$store.state.offline" class="ma-2 pa-2" color="cyan darken-2 white--text" v-on:click="doLogin">login</v-btn>
            <v-btn class="ma-2 pa-2" text v-on:click="cancel">annulla</v-btn>
            <v-btn text
              :disabled="$store.state.offline"
              class="ma-2 pa-2" 
              :to="{ path: '/recovery'}">
                recupera password
            </v-btn>
            </div>
        </v-card-actions>
    </v-card>
    
    </div>
</template>


<script>

import jwtDecode from "jwt-decode";
import {mastercal_welcome2} from "../utils/common"
import {f_rules} from '../utils/commonUtils'

export default {
  props: {
      error: {
          type: String,
          default: ""
      },
  },
  data() {
    return {
        welcome_message: mastercal_welcome2,
        username: null,
        password: null,
        err: null,
        rules: f_rules,
        login_error: false,
        errorMessage: "default error message",
        loading_dbs: false,
        dtoken: null,
        image_data: "https://cdn.vuetifyjs.com/images/parallax/material.jpg",
        loggedUser: null,
    }
  },
  watch:{
        "$store.state.loading_dbs": {
            deep: false,
            async handler(){   
                console.log('LOGIN - CHANGE STATE LOADING DB',this.$store.state.loading_dbs, 'local LOADING_DBS', this.loading_dbs) 
                if (this.loading_dbs && !this.$store.state.loading_dbs && this.loggedUser) {
                    await this.$store.dispatch('startSyncDbs', {pouch: this.$store.state.$pouch, axios: this.axios, user: this.loggedUser})
                    this.$store.commit("login", { token: this.dtoken });
                    this.loading_dbs = false
                    this.$router.push('/')
                }
            }
       }
    },
    beforeMount() {
        localStorage.removeItem("__jwt")
        this.$store.commit("logout")        
    },
    async mounted() {
        this.image_data = "img/metrycal/logo.png"; //process.env.VUE_APP_CERTIFICATE_HOST + "/images/logo.png"
    },
    methods: {

        async doLogin(){
            this.loading_dbs = true
            let token = null;
            this.dtoken = null;
            if (!this.username || !this.password) {
              this.errorMessage = "inserire username e password"
              this.login_error = true
              this.loading_dbs = false
            }
            let res = await this.axios.post("mastercal/auth/login", {username: this.username, pwd: this.password}).catch(error => {
                
                console.log("error status", error);
                this.errorMessage = "errore di autenticazione - riprovare. Se il problema persiste contattare l'amministratore"
                this.login_error = true
                this.loading_dbs = false
                return       
            });
            //console.log("$$ RES",res)
            if (!res){
                console.log("$$ error")
                this.login_error = true
                this.loading_dbs = false
                return;
            }
            token = res.data.token;
            localStorage.setItem("__jwt", token);

            this.axios.defaults.headers.common['Authorization'] = "Bearer " + token;
            this.dtoken = jwtDecode(token)
            this.loggedUser = res.data.user
            await this.$store.dispatch('setUser', {user: this.loggedUser})
            await this.$store.dispatch('setUsers', {pouch: this.$store.state.$pouch, axios: this.axios})
            // await this.$store.dispatch('deleteDbs', {pouch: this.$store.state.$pouch, user: this.loggedUser});
            //let syncRes = await this.$store.dispatch('startSyncDbs', {pouch: this.$store.state.$pouch, axios: this.axios})
            //if (!syncRes) {
                await this.$store.dispatch('startCopyDbs', {pouch: this.$store.state.$pouch, axios: this.axios, user: this.loggedUser})
            //} else {
            //    this.$store.commit("login", { token: this.dtoken });
            //    this.loading_dbs = false
            //    this.$router.push('/');
            //
            //}
            // this.$store.commit('initPouch', {pouch: this.$store.state.$pouch, axios: this.axios, token: dtoken})
            
            //this.$store.commit("login", {token: dtoken});
            
        },

        cancel(){
            this.username = null;
            this.password = null;
        },
    }
}
</script>
